import { c as _c } from "react/compiler-runtime";
import type { CSSProperties } from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
type SortableItemProps = {
  id: string;
  children: React.ReactNode;
};
export default function SortableItem(t0) {
  const $ = _c(15);
  const {
    id,
    children
  } = t0;
  let t1;
  if ($[0] !== id) {
    t1 = {
      id
    };
    $[0] = id;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging
  } = useSortable(t1);
  let t2;
  if ($[2] !== transform) {
    t2 = CSS.Translate.toString(transform);
    $[2] = transform;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = isDragging ? 999 : undefined;
  const t4 = isDragging ? "relative" : undefined;
  let t5;
  if ($[4] !== t2 || $[5] !== t3 || $[6] !== t4 || $[7] !== transition) {
    t5 = {
      transform: t2,
      transition,
      zIndex: t3,
      position: t4
    };
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
    $[7] = transition;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const style = t5;
  let t6;
  if ($[9] !== attributes || $[10] !== children || $[11] !== listeners || $[12] !== setNodeRef || $[13] !== style) {
    t6 = <li ref={setNodeRef} style={style} {...attributes} {...listeners}>{children}</li>;
    $[9] = attributes;
    $[10] = children;
    $[11] = listeners;
    $[12] = setNodeRef;
    $[13] = style;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
}